import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import dynamic from 'next/dynamic';
import { Modal, notification, Spin, Affix } from 'antd';
import SelectCountriesQuestionVisa from '@/componentWebs/Common/SelectCountriesQuestionVisa';
import CircleResult from '@/componentWebs/Common/CircleResult';
import moment from 'moment';

const OwlCarousel = dynamic(() => import(`@/componentWebs/Global/OwlCarousel`), {
  ssr: false,
  loading: () => null,
});

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class SliderQuangCao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleModal: false,
      activeTab: '1',
      idCountries: '',
      dataQuizz: [],
      textCountries: '',
      dataTab: [],
      currentQuestion: 1,
      activeAnserArr: '',
      result: [],
      loading: false,
      name: '',
      email: '',
      mobile: '',
      textWarning: '',
      key: Math.random(),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;
    if (visible !== nextProps.visible) {
      this.setState({
        visibleModal: true,
      });
    }
  }

  fetchQuizz = rec => {
    const { dispatch } = this.props;
    this.setState({
      textCountries: rec.countrieName,
    });

    dispatch({
      type: 'webs/fetchQuiz',
      payload: {
        filter: {
          countriesId: rec.id,
        },
      },
      callback: res => {
        const dataQuizz =
          (res &&
            res.result &&
            res.result.list &&
            res.result.list[0] &&
            res.result.list[0].quizz) ||
          [];

        const dataTab = ['1'];
        const dataForm = ['2', '3'];
        const orderArr =
          (dataQuizz && dataQuizz.length && dataQuizz.map(item => `question_${item.orderBy}`)) ||
          [];

        this.setState({
          dataQuizz,
          idCountries: rec.id,
          dataTab: [...dataTab, ...orderArr, ...dataForm],
          textWarning: dataQuizz && dataQuizz.length === 0 ? "Quốc gia bạn chọn chưa có câu hỏi" : ""
        });
      },
    });
  };

  handleNext = () => {
    const { idCountries, dataQuizz, dataTab, activeTab, currentQuestion, result, activeAnserArr } = this.state;
    if (!idCountries) {
      this.setState({
        textWarning: 'Bạn chưa chọn quốc gia',
      });
      // notification.error({
      //   message: 'Bạn chưa chọn quốc gia',
      //   placement: 'bottomRight',
      //   style: { background: '#fff1f0' },
      // });
      return;
    }
    if (dataQuizz && dataQuizz.length === 0) {
      // this.setState({
      //   textWarning: 'Quốc gia bạn chọn chưa có câu hỏi',
      // });
      // notification.error({
      //   message: 'Quốc gia bạn chọn chưa có câu hỏi',
      //   placement: 'bottomRight',
      //   style: { background: '#fff1f0' },
      // });
      return;
    }

    if (activeTab.includes("question_") && !activeAnserArr && activeAnserArr !== 0) return

    const ind = dataTab.findIndex(x => x === activeTab);
    if (ind !== -1 && ind < dataTab.length - 1) {
      this.setState({
        activeTab: dataTab[ind + 1],
        currentQuestion: result && result.length > 0 ? currentQuestion + 1 : 1,
        activeAnserArr: '',
        textWarning: '',
      });
    }
  };

  handleAnswer = (answer, index, item) => {
    const { result } = this.state;
    const newResult = [...result];

    const newItem = {
      question: item.question,
      orderBy: item.orderBy,
      answer: [answer],
    };

    const ind = result.findIndex(x => (x && x.orderBy) === newItem.orderBy);

    if (ind !== -1) {
      newResult[ind] = newItem;
    } else {
      newResult.push(newItem);
    }

    this.setState({
      activeAnserArr: index,
      result: newResult,
    });
  };


  handleSubmit = e => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { name, email, mobile, idCountries, result, dataTab, activeTab } = this.state;

    // console.log('result: ', result);

    const valueItem = {
      countriesId: idCountries,
      mobile,
      fullname: name,
      email,
      dateCreated: moment(),
      results: result,
    };

    this.setState({
      loading: true,
    });

    dispatch({
      type: 'webs/createQuizzCustomer',
      payload: valueItem,
      callback: res => {
        this.setState({
          loading: false,
        });
        if (res && res.success) {
          const ind = dataTab.findIndex(x => x === activeTab);
          if (ind !== -1 && ind < dataTab.length - 1) {
            this.setState({
              activeTab: dataTab[ind + 1],
              key: Math.random(),
            });
          }
        } else {
          notification.error({
            message: res && res.error && res.error.message,
            placement: 'bottomRight',
            style: { background: '#fff1f0' },
          });

          // const ind = dataTab.findIndex(x => x === activeTab);
          // if (ind !== -1 && ind < dataTab.length - 1) {
          //   this.setState({
          //     activeTab: dataTab[ind + 1],
          //     key: Math.random(),
          //   });
          // }
        }
      },
    });
  };

  handleChangeForm = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  cancel = () => {
    this.setState({
      visibleModal: false,
      activeTab: '1',
      idCountries: '',
      dataQuizz: [],
      textCountries: '',
      dataTab: [],
      currentQuestion: 1,
      activeAnserArr: '',
      result: [],
      loading: false,
      name: '',
      email: '',
      mobile: '',
      textWarning: '',
    });
  };

  render() {
    const {
      hideNav,
      visibleModal,
      activeTab,
      dataQuizz,
      textCountries,
      currentQuestion,
      activeAnserArr,
      loading,
      key,
      textWarning,
    } = this.state;

    // console.log("activeAnserArr: ", activeAnserArr);

    const newDataQuizz =
      (dataQuizz &&
        dataQuizz.length > 0 &&
        dataQuizz.sort((a, b) => Number(a.orderBy) - Number(b.orderBy))) ||
      [];

    const totalQuestion = dataQuizz.length;
    const percent = (currentQuestion / totalQuestion) * 100;

    // console.log('dataQuizz, : ', dataQuizz, activeTab);

    return (
      <Modal
        visible={visibleModal}
        className="modal-question-visa"
        width="100%"
        style={{ top: 0, margin: 0 }}
        bodyStyle={{ height: '96vh' }}
        maskStyle={{ backgroundColor: '#fff' }}
        // bodyStyle={{ paddingTop: 5 }}
        // confirmLoading={spinning}
        onCancel={this.cancel}
        footer={null}
        title={null}
      >
        <Spin spinning={loading}>
          <div className="modal-question-visa__wrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-4 hidden-m-t modal-question-visa__img-wrapper">
                  <div className="modal-question-visa__img">
                    <img src="/static/vietnamTickets/images/Group10604.jpg" />
                  </div>
                </div>
                <div className="col-xl-8">
                  <div className="question-box">
                    <div className="question-box-top">
                      {/* Chon nuoc  */}
                      {activeTab === '1' && (
                        <div className="question-box__countries">
                          <h2 className="title">Lựa chọn Quốc gia mà bạn sẽ đặt chân đến</h2>

                          <SelectCountriesQuestionVisa
                            label="Quốc gia"
                            placeholder="Nhập nước bạn muốn đến"
                            defaultValue={textCountries}
                            key="from"
                            // defaultValue={diaDiemText}
                            // isInternational={isInternational}
                            onChange={rec => this.fetchQuizz(rec)}
                            clearValue={() => this.setState({
                              idCountries: '',
                              dataQuizz: [],
                              textWarning: ''
                            })}
                          />

                          {textWarning && <div className="text-warning">{textWarning}</div>}
                        </div>
                      )}

                      {/* Cac cau hoi  */}
                      {/* {newDataQuizz &&
                        newDataQuizz.length > 0 &&
                        newDataQuizz.map(item => ( */}
                      <div
                        // className={
                        //   activeTab === `question_${item.orderBy}`
                        //     ? 'question-box__anwser'
                        //     : 'question-box__anwser none'
                        // }
                        className="question-box__anwser"
                      >
                        {activeTab.includes('question_') && (
                          <div className="meter animate">
                            <span
                              id="myBar_loading"
                              style={{ width: `${Math.ceil(percent)}%`, transition: 'all 0.5s' }}
                            >
                              <span>{`${currentQuestion}/${totalQuestion} câu`} </span>
                            </span>

                            {/* <div className="text"></div> */}
                          </div>
                        )}

                        {newDataQuizz &&
                          newDataQuizz.length > 0 &&
                          newDataQuizz.map(item => (
                            <div
                              className={activeTab === `question_${item.orderBy}` ? '' : ' none'}
                              key={item.orderBy}
                            >
                              <div className="question-box__anwser-title">{`${item.question}`}</div>

                              <ul className="question-box__anwser__main">
                                {item.answer &&
                                  item.answer.length > 0 &&
                                  item.answer.map((x, index) => (
                                    <li
                                      className={activeAnserArr === index ? 'active' : ''}
                                      onClick={() => this.handleAnswer(x, index, item)}
                                      key={index}
                                    >
                                      {x}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          ))}
                      </div>
                      {/* ))} */}

                      {activeTab === '2' && (
                        <div className="question-box__lienHe ">
                          <img src="/static/vietnamTickets/images/Group 10611.png" />
                          <div className="plus">
                            Wow! Chúng ta đã hoàn thành bài kiểm tra. Điền thêm thông tin bên dưới
                            để biết kết quả này bạn nhé!
                          </div>
                          <form className="question-box__form" onSubmit={this.handleSubmit}>
                            <input
                              className="question-box__input"
                              required
                              placeholder="Họ và tên"
                              name="name"
                              onChange={this.handleChangeForm}
                            />
                            <input
                              className="question-box__input"
                              required
                              placeholder="Email của bạn"
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                              name="email"
                              onChange={this.handleChangeForm}
                            />
                            <input
                              className="question-box__input"
                              required
                              placeholder="SĐT của bạn"
                              pattern="\d+"
                              name="mobile"
                              onChange={this.handleChangeForm}
                            />

                            <button type="submit" className="btn-tieptheo btn-xacnhan flex-center ">
                              Xác nhận
                            </button>
                          </form>
                        </div>
                      )}

                      {/* Ket qua  */}

                      {activeTab === '3' && (
                        <div className="question-box__result">
                          <div className="question-box__result__title">
                            Khả năng đậu của bạn cho visa đi {textCountries}
                          </div>

                          <CircleResult key={key} />

                          <div className="plus">
                            Trong vòng 4 giờ làm việc, Nhân viên của MYBOOKING sẽ liên hệ bạn để hỗ
                            trợ và tư vấn miễn phí, giúp bạn nâng cao tỷ lệ đậu visa của mình.
                          </div>
                        </div>
                      )}
                    </div>
                    {activeTab !== '2' && (
                      <div className="btn-wrapper-visa flex-a-c ">
                        {activeTab !== '3' ? (
                          <div className={(activeTab.includes("question_") && !activeAnserArr && activeAnserArr !== 0) ?
                            "btn-tieptheo disable flex-center" : "btn-tieptheo flex-center"
                          } onClick={this.handleNext}>
                            Tiếp theo
                          </div>
                        ) : (
                          <>
                            <div
                              className="btn-tieptheo btn-return flex-center"
                              onClick={() =>
                                this.setState({
                                  activeTab: '1',
                                  idCountries: '',
                                  dataQuizz: [],
                                  textCountries: '',
                                  dataTab: [],
                                  currentQuestion: 1,
                                  activeAnserArr: '',
                                  result: [],
                                  name: '',
                                  email: '',
                                  mobile: '',
                                  textWarning: '',
                                })
                              }
                            >
                              Kiểm tra lại
                            </div>
                            <div
                              className="btn-tieptheo btn-home flex-center"
                              onClick={() => (window.location.href = '/')}
                            >
                              Về trang chủ
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default SliderQuangCao;
